document.addEventListener('DOMContentLoaded', () => {
  const pageContent = document.querySelector('.brochurePrijzen__pageContent');
  if (pageContent) {
    const toggleOptions = document.querySelector('.form-options');
    const formDigitaal = document.querySelector('.formBrochure--digitaal');
    const formPost = document.querySelector('.formBrochure--post');

    toggleOptions.addEventListener('click', (event) => {
      const option = event.target.closest('li');
      if (!option) return;

      // Verwijder actieve class van alle toggles
      toggleOptions.querySelectorAll('li').forEach(opt => opt.classList.remove('-active'));
      // Voeg actieve class toe aan de geselecteerde toggle
      option.classList.add('-active');

      // Toon/verberg formulieren en werk URL bij
      if (option.id === 'email') {
        formDigitaal.classList.add('-active');
        formPost.classList.remove('-active');
        updateUrlParameter('form', 'email');
      } else if (option.id === 'post') {
        formDigitaal.classList.remove('-active');
        formPost.classList.add('-active');
        updateUrlParameter('form', 'post');
      }
    });

    // Functie om URL-parameter bij te werken
    function updateUrlParameter(key, value) {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set(key, value);
      window.history.pushState({}, '', '?' + urlParams.toString());
    }

    // Controleer URL-parameters bij het laden van de pagina
    const urlParams = new URLSearchParams(window.location.search);
    const formType = urlParams.get('form');
    if (formType === 'post') {
      document.getElementById('post').click();
    } else {
      document.getElementById('email').click();
    }
  }
});
